export default function getBaseUrl() {
  const hostname = window.location.hostname;
  return hostname.endsWith('.localhost')
    ? `http://${hostname}/api/dev`
    : `https://${hostname}/api/prod`;
}
